onComplete(function () {
  const mobileNavLink = document.querySelectorAll('.navbar-overlay-content .nav-link');
  mobileNavLink.forEach((link, index) => {
    link.style.setProperty('--i', index + 1);
  });
  document.querySelectorAll(".growth-preview-button, .growth-preview .image").forEach(button => {
    button.addEventListener("click", function (event) {
      let parentDiv = this.closest(".growth-preview");
      if (parentDiv) {
        event.stopImmediatePropagation();
        parentDiv.classList.toggle("active");
        if (window.innerWidth <= 991) {
          if (parentDiv.classList.contains("active")) {
            let blogContent = parentDiv.querySelector(".blog-item-preview-content");
            if (blogContent) {
              blogContent.scrollIntoView({
                behavior: "smooth"
              });
            }
          }
        }
      }
    });
  });
});